<template>
  <div class="mcp-tab-content">
    <!-- <a-form-model v-if="type === 'cursor'">
      <a-form-model-item label="API AccessKey" v-bind="formItemLayout">
        <base-select
          v-model="form.api_access_key"
          resource="credentials"
          showSync
          labelInValueKeyName="secret"
          :select-props="{ placeholder: $t('common.tips.select', ['API AccessKey']) }"
          :params="{ type: 'aksk', project_id: $store.getters.userInfo.projectId, system: $store.getters.isAdminMode }"
          @update:item="updateApiAccessKeyItem">
          <template #optionLabelTemplate="{ item }">
            <span>{{ item.id }} - {{ $moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
        </base-select>
        <div slot="extra">
          {{ $t('ai.mcp.api_access_key_tooltip')}}
          <help-link :href="href">{{$t('cloudenv.go_create')}}</help-link>
        </div>
      </a-form-model-item>
    </a-form-model> -->

    <p class="mcp-tab-description">
      {{ type === 'cursor' ? $t('ai.mcp.cursor_description') : type === 'claude' ? $t('ai.mcp.cloud_code_description') : $t('ai.mcp.openclaw_description') }}
    </p>
    <div class="mcp-code-wrapper">
      <pre class="mcp-code-block"><code>{{ mcpConfigJsonData }}</code></pre>
      <a-icon type="copy" class="mcp-copy-icon" @click="handleCopy(mcpConfigJsonData)" />
    </div>
  </div>
</template>

<script>
const DEFAULT_CURSOR_JSON = `{
  "mcpServers": {
    "server-name": {
      "url": "http://localhost:3000/mcp",
      "headers": {
        "AK": "value",
        "SK": "value"
      }
    }
  }
}`

const DEFAULT_CLAUDE_JSON = 'claude mcp add --transport sse private-api https://api.company.com/sse --header "X-API-Key: your-key-here"'

export default {
  name: 'McpJson',
  props: {
    type: {
      type: String,
      default: 'cursor',
    },
  },
  data () {
    return {
      mcpConfigJson: '',
      apiAccessKeys: [],
      form: {
        api_access_key: undefined,
        apiAccessKey: {},
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      // href: '/credentials',
      cursorPrefixes: [
        this.$t('ai.mcp.cursor_prefix'),
      ],
      claudePrefixes: [
        this.$t('ai.mcp.claude_prefix'),
        this.$t('ai.mcp.claude_prefix_1'),
        this.$t('ai.mcp.claude_prefix_2'),
      ],
    }
  },
  computed: {
    mcpConfigJsonData () {
      let base = this.mcpConfigJson || (this.type === 'cursor' ? DEFAULT_CURSOR_JSON : DEFAULT_CLAUDE_JSON)
      if (this.form.apiAccessKey && this.form.apiAccessKey.id && this.form.apiAccessKey.blob) {
        const id = this.form?.apiAccessKey?.id ?? ''
        const secret = JSON.parse(this.form?.apiAccessKey?.blob ?? '{}').secret ?? ''
        // "AK"/"SK" 后的 value 可能是任意字符，用正则匹配并替换
        base = base
          .replace(/"AK"\s*:\s*"(?:[^"\\]|\\.)*"/, () => `"AK": ${JSON.stringify(id)}`)
          .replace(/"SK"\s*:\s*"(?:[^"\\]|\\.)*"/, () => `"SK": ${JSON.stringify(secret)}`)
      }
      if (this.type === 'claude') {
        base = this.claudePrefixes.join('\n') + '\n' + base
      }
      if (this.type === 'cursor') {
        base = this.cursorPrefixes.join('\n') + '\n' + base
      }
      return base
    },
  },
  created () {
    this.fetchConfig()
  },
  methods: {
    async fetchConfig () {
      try {
        const ret = await new this.$Manager('mcp-servers-config', 'v1').list({
          params: {
            type: this.type,
          },
        })
        const data = ret?.data?.data ?? ret?.data ?? ret
        this.mcpConfigJson = Array.isArray(data) ? JSON.stringify(data, null, 2) : (typeof data === 'object' ? JSON.stringify(data, null, 2) : String(data || ''))
      } catch (e) {
        this.mcpConfigJson = ''
        console.error('fetch mcp_servers_config failed', e)
      }
    },
    updateApiAccessKeyItem (item) {
      this.form.apiAccessKey = item
    },
    handleCopy (text) {
      if (!text) return
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success(this.$t('common.text00095'))
      } catch (err) {
        this.$message.error(this.$t('common.text00096'))
      } finally {
        document.body.removeChild(textarea)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.mcp-code-wrapper {
  position: relative;

  &:hover .mcp-copy-icon {
    opacity: 1;
    border-radius: 4px;
  }
}

.mcp-code-block {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 16px;
  overflow-x: auto;
  background-color: #f0f0f0;

  code {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
    font-size: 13px;
    color: #333;
    white-space: pre;
  }
}

.mcp-copy-icon {
  position: absolute;
  top: 12px;
  right: 12px;
  font-size: 16px;
  color: #666;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s, color 0.2s;
  z-index: 10;
  background: rgba(255, 255, 255, 0.8);
  padding: 4px;
  border-radius: 2px;

  &:hover {
    color: #1890ff;
    background: rgba(255, 255, 255, 0.95);
  }
}
</style>
